import * as React from 'react'

export type PaginationInfo = { page: number; size: number }

export type Pagination = {
  page: number
  size: number
  pages: number[]
  paginate: (page?: number) => PaginationInfo
  setSize: (size?: number) => PaginationInfo
  set: (page?: number, size?: number) => void
}

export function usePagination(initialPagination: PaginationInfo, items: any[]): Pagination {
  const [pagination, setPagination] = React.useState<PaginationInfo>(initialPagination)

  const maxPage = Math.ceil(items.length / pagination.size)

  return {
    ...pagination,
    pages: Array.from({ length: maxPage }, (_, i) => i + 1),
    paginate,
    setSize,
    set,
  }

  function set(page?: number, size?: number) {
    setPagination({ page: page || pagination.page, size: size || pagination.size })
  }

  function paginate(page?: number): PaginationInfo {
    if (page === undefined || page < 1 || page > maxPage) {
      return pagination
    }
    const nextPagination = { ...pagination, page }
    setPagination(nextPagination)
    return nextPagination
  }

  function setSize(size?: number): PaginationInfo {
    if (size === undefined || size <= 0) {
      return pagination
    }
    const nextPagination = { ...pagination, size }
    setPagination(nextPagination)
    return nextPagination
  }
}
